import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import images from "../../assets/images";
import question from "../../assets/images/question.png";
import Button from "../button";
import "./style.css";

const CustomModal = (props) => {
  return (
    <Modal
      onClick={(e) => e.stopPropagation()}
      show={props?.show}
      centered
      onHide={props?.close}
    >
      <button className="closeButton" onClick={props?.close}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <Modal.Body className="text-center">
        {props?.success ? (
          <img src={images.modal.check} alt="check" className="modalImage" />
        ) : (
          <img src={question} alt="question" className="modalImage" />
        )}
        <div className="modalContent">
          <h2 className="modalHeading">{props?.heading}</h2>

          {props.children}

          {props?.success ? (
            <Button
              onClick={props?.close}
              variant="primaryButton"
              text={props?.btnTxt ? props?.btnTxt : "Ok"}
              loading={props.loading}
            />
          ) : (
            <>
              <Button
                onClick={props?.action}
                variant="primaryButton"
                text="Yes"
                className="me-2"
                loading={props.loading}
              />
              <Button
                onClick={props?.close}
                variant="secondaryButton"
                text="No"
              />
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
